
export class RegistrationAddress {

    address: string;
    addressNumber: string;
    addressComplement: string;
    addressCountry: string;
    addressCity: string;
    addressState: string;
    addressZip: string;

    constructor() {
        this.address = null;
        this.addressNumber = null;
        this.addressComplement = null;
        this.addressCountry = null;
        this.addressCity = null;
        this.addressState = null;
        this.addressZip = null;
    }

}


// WEBPACK FOOTER //
// ./src/models/registrationaddress.ts